import styled, { css } from "styled-components";

export const RunnerOddsContainer = styled.div<{ isInlinePP?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ isInlinePP }) =>
    isInlinePP &&
    css`
      padding-left: 12px;
      border: 1px solid ${({ theme }) => `${theme.colorTokens.border.default}`};
      border-bottom: none;
    `}
`;

export const OddsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  width: 100%;
  font-family: Roboto-Regular, sans-serif;
  font-size: 14px;
  color: ${({ theme }) => `${theme.colorTokens.content.default}`};
  height: 20px;
  line-height: 20px;
`;

export const MorningOdds = styled.span`
  display: flex;
  flex-direction: row;
  margin-right: 16px;
  color: ${({ theme }) => `${theme.colorTokens.content.subtle}`};
`;

export const OddsTitle = styled.span`
  font-weight: 700;
  margin-right: 4px;
  color: ${({ theme }) => `${theme.colorTokens.content.default}`};
`;

export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  margin-top: 8px;
`;

export const Comment = styled.span`
  font-family: Roboto-Regular, sans-serif;
  font-size: 14px;
  color: ${({ theme }) => `${theme.colorTokens.content.subtle}`};
  line-height: 18px;
`;

export const SilkContainer = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: 12px;
`;

export const Silk = styled.img`
  height: 46px;
  width: 46px;
`;

export const Odd = styled.span`
  display: flex;
  align-items: center;
  &:last-child {
    color: ${({ theme }) => `${theme.colorTokens.content.subtle}`};
  }
`;

export const RunnerOddsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
